import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-termination',
  templateUrl: './confirm-termination.component.html',
  styleUrls: ['./confirm-termination.component.scss']
})
export class ConfirmTerminationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmTerminationComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  confirm(isNew) {
    this.dialogRef.close(isNew);
  }

}
